// extracted by mini-css-extract-plugin
export default {"btns":"styles_btns__ouqT7","disabled":"styles_disabled__ZGXuo","info":"styles_info__0ESch"};